import React from 'react';
import { Modal, ModalHeader, Media, ModalBody, ModalFooter, Col, Button, Row, Form } from 'reactstrap';
import Select from 'react-select';
import { Dialog } from 'primereact/dialog';

//MULTISELECT

import { MultiSelect } from 'primereact/multiselect';
//gato




export const ModalViewSection = (props) => {

    const { modalTitleSection, modalSection, toggleSection, typeModal = "typeSection", selected, onChange, data, saveUpdateSections, loading,
        listSection, listSect, handleSelectValues, sectionSelected, name_user
    } = props;
    ////console.log("Sections Total:",listSection);
    ////console.log("Sections Select:",listSect);





    return (
        <Dialog
            header={modalTitleSection}
            visible={modalSection}
            onHide={toggleSection}
            blockScroll
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
            className="small-dialog"



        >
            {
                typeModal === "typeSection" ?
                    <Form className="form" role="form" onSubmit={saveUpdateSections}>
                        <ModalBody>
                            <div>

                                {/* Header usuario */}
                                <div className="user-header mb-3">
                                    <div className="d-flex align-items-center user-header-content">
                                        <div className="user-avatar">
                                            {name_user?.charAt(0)}
                                        </div>

                                        <div className="user-info">
                                            <div className="user-name">
                                                {name_user}
                                            </div>
                                            <div className="user-subtitle">
                                                Configuración de secciones/áreas para el usuario
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Card Secciones / Áreas */}
                                <div className="sections-card">

                                    <div className="sections-card-header">
                                        Secciones / Áreas
                                    </div>

                                    <div className="sections-card-body">
                                        <Col sm="12" className='pb-5' >
                                            <Select
                                                isMulti
                                                name="listSection"
                                                value={listSection}
                                                onChange={(e) => handleSelectValues(e, "listSection")}
                                                options={listSect}
                                                className="basic-multi-select"
                                                classNamePrefix="select"
                                                placeholder="Selecciona una o varias opciones"
                                                noOptionsMessage={() => "Sin opciones"}
                                                isSearchable
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: "#b6bdc4"
                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }),
                                                    control: (base) => ({
                                                        ...base,
                                                        fontSize: "10px"
                                                    }),
                                                }}
                                            />
                                        </Col>
                                    </div>

                                </div>

                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Button size='sm' outline color='primary' type='submit' className={loading ? 'disabled progress-bar-animated progress-bar-striped' : ''} disabled={loading} >
                                Actualizar Secciones/Áreas
                            </Button>
                            <Button size="sm" className='btn-air-light' outline color='danger' type='button' onClick={toggleSection}>
                                Cancelar
                            </Button>
                        </ModalFooter>


                    </Form>


                    : ""


            }
        </Dialog>
    )
}